/* Routing */
import {Link, Outlet} from "react-router-dom";
/* Contexts */
import useAuth from "../../../hooks/useAuth";
import { DataProvider } from "../../../context/DataProvider";
import {DeceasedProvider} from "../../../context/DeceasedProvider";
/* Components */
import AdminMenu from "../navigation/AdminMenu";
import { PagerProvider } from "../../../context/PagerProvider";
import {useEffect} from "react";
import useRefreshToken from "../../../hooks/useRefreshToken";
import MentionsLegales from "../../../pages/MentionsLegales";

export default function AdminLayout() {
    const { auth } = useAuth();
    const token = auth?.token;
    const refresh = useRefreshToken()
    const thisYear = new Date().getFullYear();

    useEffect(() => {
        if (localStorage?.getItem("old_refresh_token") !== null) {
            localStorage.setItem("refresh_token", localStorage.getItem("old_refresh_token"));
            localStorage.removeItem("old_refresh_token");
            refresh()
        }
    }, []);

    return (
        <>
            <div className="admin">
                <AdminMenu user={auth?.user}/>
                <PagerProvider>
                    <DataProvider>
                        <DeceasedProvider>
                            <Outlet/>
                        </DeceasedProvider>
                    </DataProvider>
                </PagerProvider>
            </div>
            <span className="footer">{thisYear} - Administration d'Obsèques en France - <Link to="/mentions-legales" target="_blank"> Mentions légales et politique de confidentialité</Link></span>
        </>
    )
}